import React, { useState, useEffect } from 'react';
import styles from './VisualCarousel.module.css';
import AnimatedCode from './AnimatedCode';
import AIVisual from './AIVisual';
import ChatbotVisual from './ChatbotVisual';
import DashboardVisual from './DashboardVisual';
import DroneVisual from './DroneVisual';
import RobotVisual from './RobotVisual';
import CloudVisual from './CloudVisual';

const VisualCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const visuals = [
    { component: AnimatedCode, label: 'Code Solutions' },
    { component: AIVisual, label: 'AI Intelligence' },
    { component: ChatbotVisual, label: 'AI Chatbot' },
    { component: DashboardVisual, label: 'Industry 4.0' },
    { component: DroneVisual, label: 'IoT Drones' },
    { component: RobotVisual, label: 'Robotics' },
    { component: CloudVisual, label: 'Cloud Infrastructure' },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % visuals.length);
    }, 4000); // Change every 4 seconds

    return () => clearInterval(interval);
  }, [visuals.length]);

  return (
    <div className={styles.carouselContainer}>
      <div className={styles.visualWrapper}>
        {visuals.map((visual, index) => {
          const VisualComponent = visual.component;
          return (
            <div
              key={index}
              className={`${styles.visualSlide} ${index === currentIndex ? styles.active : ''}`}
            >
              <VisualComponent />
            </div>
          );
        })}
      </div>
      <div className={styles.carouselIndicators}>
        {visuals.map((visual, index) => (
          <button
            key={index}
            className={`${styles.indicator} ${index === currentIndex ? styles.active : ''}`}
            onClick={() => setCurrentIndex(index)}
            aria-label={`Go to ${visual.label}`}
          />
        ))}
      </div>
      <div className={styles.carouselLabel}>
        {visuals[currentIndex].label}
      </div>
    </div>
  );
};

export default VisualCarousel;

